import { render, staticRenderFns } from "./FooterInfo.vue?vue&type=template&id=3041be7e&scoped=true&"
import script from "./FooterInfo.vue?vue&type=script&lang=js&"
export * from "./FooterInfo.vue?vue&type=script&lang=js&"
import style0 from "./FooterInfo.vue?vue&type=style&index=0&id=3041be7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3041be7e",
  null
  
)

export default component.exports